export default __webpack_public_path__ + "static/media/trust.10d0d1d5.png";